import { Command } from 'cmdk'

import { Flex, Skeleton } from '@buffer-mono/popcorn'

import styles from './CommandBar.module.css'

import type { JSX } from 'react'

const COMMAND_SKELETON_IDS = [
  'command-skeleton-1',
  'command-skeleton-2',
  'command-skeleton-3',
  'command-skeleton-4',
  'command-skeleton-5',
]

export function CommandBarLoading(): JSX.Element {
  return (
    <Command.Loading className={styles.loading}>
      <Flex direction="column" gap="xs">
        {COMMAND_SKELETON_IDS.map((skeletonId) => (
          <Flex
            key={skeletonId}
            align="center"
            gap="sm"
            className={styles.loadingItem}
          >
            <Skeleton width={24} height={24} />
            <Skeleton width="60%" height={20} />
          </Flex>
        ))}
      </Flex>
    </Command.Loading>
  )
}
